// Dados da PNAD
// Dados calibrados com calculadora NEXO

export const BRASIL_MEDIA = 3369;

// Valores válidos fornecidos
export const SALARIOS_MEDIOS_ESTADO = {
  "AC": 2631,  // Acre
  "AL": 2352,  // Alagoas  
  "AP": 2837,  // Amapá
  "AM": 2426,  // Amazonas
  "BA": 2185,  // Bahia
  "CE": 2197,  // Ceará
  "DF": 5381,  // Distrito Federal
  "ES": 3344,  // Espírito Santo
  "GO": 3260,  // Goiás
  "MA": 2039,  // Maranhão
  "MT": 3524,  // Mato Grosso
  "MS": 3521,  // Mato Grosso do Sul
  "MG": 3022,  // Minas Gerais
  "PA": 2409,  // Pará
  "PB": 2302,  // Paraíba
  "PR": 3674,  // Paraná
  "PE": 2565,  // Pernambuco
  "PI": 2313,  // Piauí
  "RJ": 3974,  // Rio de Janeiro
  "RN": 2592,  // Rio Grande do Norte
  "RS": 3640,  // Rio Grande do Sul
  "RO": 2969,  // Rondônia
  "RR": 2942,  // Roraima
  "SC": 3953,  // Santa Catarina
  "SP": 3972,  // São Paulo
  "SE": 2463,  // Sergipe
  "TO": 2956   // Tocantins
} as const;

// CALIBRADO: Ranking baseado nos valores válido
export const RANKING_ESTADOS = [
  { posicao: 1, uf: "DF", valor: 5381, nome: "Distrito Federal" },
  { posicao: 2, uf: "RJ", valor: 3974, nome: "Rio de Janeiro" },
  { posicao: 3, uf: "SP", valor: 3972, nome: "São Paulo" },
  { posicao: 4, uf: "SC", valor: 3953, nome: "Santa Catarina" },
  { posicao: 5, uf: "PR", valor: 3674, nome: "Paraná" },
  { posicao: 6, uf: "RS", valor: 3640, nome: "Rio Grande do Sul" },
  { posicao: 7, uf: "MT", valor: 3524, nome: "Mato Grosso" },
  { posicao: 8, uf: "MS", valor: 3521, nome: "Mato Grosso do Sul" },
  { posicao: 9, uf: "ES", valor: 3344, nome: "Espírito Santo" },
  { posicao: 10, uf: "GO", valor: 3260, nome: "Goiás" },
  { posicao: 11, uf: "MG", valor: 3022, nome: "Minas Gerais" },
  { posicao: 12, uf: "RO", valor: 2969, nome: "Rondônia" },
  { posicao: 13, uf: "TO", valor: 2956, nome: "Tocantins" },
  { posicao: 14, uf: "RR", valor: 2942, nome: "Roraima" },
  { posicao: 15, uf: "AP", valor: 2837, nome: "Amapá" },
  { posicao: 16, uf: "AC", valor: 2631, nome: "Acre" },
  { posicao: 17, uf: "RN", valor: 2592, nome: "Rio Grande do Norte" },
  { posicao: 18, uf: "PE", valor: 2565, nome: "Pernambuco" },
  { posicao: 19, uf: "SE", valor: 2463, nome: "Sergipe" },
  { posicao: 20, uf: "AM", valor: 2426, nome: "Amazonas" },
  { posicao: 21, uf: "PA", valor: 2409, nome: "Pará" },
  { posicao: 22, uf: "AL", valor: 2352, nome: "Alagoas" },
  { posicao: 23, uf: "PI", valor: 2313, nome: "Piauí" },
  { posicao: 24, uf: "PB", valor: 2302, nome: "Paraíba" },
  { posicao: 25, uf: "CE", valor: 2197, nome: "Ceará" },
  { posicao: 26, uf: "BA", valor: 2185, nome: "Bahia" },
  { posicao: 27, uf: "MA", valor: 2039, nome: "Maranhão" }
] as const;

// Distribuições estaduais baseadas em dados NEXO
export const DISTRIBUICAO_ESTADUAL_APROXIMADA = {
  // DF - Categoria especial (R$ 2500 = 49% vs nacional 62%)
  "DF": {
    10: 911, 20: 1771, 30: 2050, 40: 2240, 50: 2589,
    60: 3054, 70: 3881, 80: 4935, 90: 8224, 95: 12653, 99: 17714
  },
  
  // Estados alta renda (R$ 2500 = 53-58% vs nacional 62%)
  // SP, RJ, RS, PR, SC
  "ALTA": {
    10: 842, 20: 1638, 30: 1895, 40: 2071, 50: 2393,
    60: 2824, 70: 3588, 80: 4562, 90: 7604, 95: 11698, 99: 16377
  },
  
  // Estados média renda (R$ 2500 = 62-67% vs nacional 62%)
  // MG, AP, ES, GO, MT, MS
  "MEDIA": {
    10: 698, 20: 1356, 30: 1569, 40: 1715, 50: 1982,
    60: 2339, 70: 2971, 80: 3778, 90: 6297, 95: 9688, 99: 13563
  },
  
  // Estados baixa renda (R$ 2500 = 70% vs nacional 62%)
  // AC, RO, TO, RR, RN, PB, PE, AL, SE
  "BAIXA": {
    10: 638, 20: 1240, 30: 1435, 40: 1568, 50: 1812,
    60: 2138, 70: 2716, 80: 3454, 90: 5757, 95: 8857, 99: 12400
  },
  
  // Estados muito baixa renda (R$ 2500 = 79% vs nacional 62%)
  // MA, CE, PI, BA, AM, PA
  "MUITO_BAIXA": {
    10: 565, 20: 1099, 30: 1271, 40: 1389, 50: 1606,
    60: 1895, 70: 2407, 80: 3061, 90: 5101, 95: 7848, 99: 10987
  }
} as const;

// CALIBRADO: Mapeamento baseado em dados reais da NEXO
export const CATEGORIA_DISTRIBUICAO = {
  // DF categoria própria
  "DF": "DF",
  
  // Estados alta renda (percentil estadual < nacional para R$ 2500)
  "SP": "ALTA", "RJ": "ALTA", "RS": "ALTA", "PR": "ALTA", "SC": "ALTA",
  
  // Estados média renda (percentil estadual ≈ nacional para R$ 2500)  
  "MG": "MEDIA", "AP": "MEDIA", "ES": "MEDIA", "GO": "MEDIA", 
  "MT": "MEDIA", "MS": "MEDIA",
  
  // Estados baixa renda (percentil estadual > nacional para R$ 2500)
  "AC": "BAIXA", "RO": "BAIXA", "TO": "BAIXA", "RR": "BAIXA", 
  "RN": "BAIXA", "PB": "BAIXA", "PE": "BAIXA", "AL": "BAIXA", "SE": "BAIXA",
  
  // Estados muito baixa renda (percentil estadual >> nacional para R$ 2500)
  "MA": "MUITO_BAIXA", "CE": "MUITO_BAIXA", "PI": "MUITO_BAIXA", 
} as const;